import React, { useCallback, useState } from "react";
import musicIcon from "@assets/images/musicIconSM.webp";
import { getValueOrDefault } from "@src/utils/ConditionHelper";
import PlayIconAudio from "@assets/images/PlayIconAudio.svg";
import { useNavigate } from "react-router-dom";
import VideoBorder from "@assets/images/borders/video-border.webp";
import { getImageUrlWithExpiry } from "@src/utils/ImageExpirtyHelper";
import type { IBookmarkMusicItems, IBookmarkMusics } from "@src/types/AppTypes";

const BookmarkMusics: React.FC<IBookmarkMusics> = ({
  item,
  removeEpisodeOrMusicMutate,
}) => {
  const navigate = useNavigate();
  const [isBookmarkedMusicImageLoading, setIsBookmarkedMusicImageLoading] =
    useState<boolean>(true);

  const onMusicsPlayClick = useCallback(
    async (item: IBookmarkMusicItems) => {
      navigate("/music/" + item.slug, {
        state: {
          fromHomePage: true,
          audio: item,
        },
      });
    },
    [navigate]
  );

  return (
    <>
      <div
        className="flex items-center justify-between relative max-md:p-4 max-sm:p-2 max-md:border max-md:border-[#89D9EE] max-md:rounded-xl"
        id={`music-${item.id}`}
      >
        <div className="grid grid-cols-[192px_1fr] max-lg:grid-cols-[100px_1fr] max-sm:grid-cols-[80px_1fr] items-center gap-3 w-full">
          <div
            className="p-1 h-32 max-md:h-24 relative rounded-[5px_15px_15px_20px] max-sm:rounded-[5px_10px_10px_10px] overflow-hidden cursor-pointer"
            onClick={() => {
              onMusicsPlayClick(item);
            }}
          >
            {isBookmarkedMusicImageLoading && (
              <div className="skeleton p-1 top-0 left-0 size-full absolute"></div>
            )}
            <img
              className="size-full rounded-xl object-cover absolute top-0 left-0 blur-sm"
              src={getValueOrDefault(
                getImageUrlWithExpiry(item.thumbnail),
                PlayIconAudio
              )}
              onLoad={() => {
                setIsBookmarkedMusicImageLoading(false);
              }}
              onError={() => {
                setIsBookmarkedMusicImageLoading(false);
              }}
              alt="bookmark-item-img"
            />
            <img
              className="size-full rounded-xl object-contain relative z-[1]"
              src={getValueOrDefault(
                getImageUrlWithExpiry(item.thumbnail),
                PlayIconAudio
              )}
              onLoad={() => {
                setIsBookmarkedMusicImageLoading(false);
              }}
              onError={() => {
                setIsBookmarkedMusicImageLoading(false);
              }}
              alt="bookmark-item-img"
            />
            <img
              className="absolute size-full top-0 left-0 z-[3]"
              src={VideoBorder}
              alt="border"
            />
          </div>
          <div className="md:pr-3">
            <div
              className="flex items-center gap-3 mb-1 max-sm:mb-1 max-sm:gap-1 cursor-pointer"
              onClick={() => {
                onMusicsPlayClick(item);
              }}
            >
              <img
                src={musicIcon}
                alt="music-icon"
                className="max-sm:w-5 w-6"
              />
              <h6 className="text-[#C52E95] text-xl max-sm:text-base">Audio</h6>
            </div>
            <div className="flex items-center justify-between">
              <h6
                className="text-primary break-words break-all line-clamp-1 text-xl max-md:text-lg max-sm:text-base w-[calc(100%-75px)] cursor-pointer"
                onClick={() => {
                  onMusicsPlayClick(item);
                }}
              >
                {item.title}
              </h6>
              <div className="flex items-center justify-between gap-2">
                <button
                  className="text-primary text-3xl"
                  onClick={() => {
                    navigate("/music/" + item.slug, {
                      state: {
                        fromHomePage: true,
                        audio: item,
                      },
                    });
                  }}
                  aria-label="Play"
                >
                  <i className="ri-play-circle-line"></i>
                </button>
                <button
                  onClick={() => {
                    removeEpisodeOrMusicMutate({
                      data: { saveable_id: item.id, saveable_type: "Music" },
                    });
                  }}
                  className="flex items-center gap-1 text-sm text-secondary duration-150 hover:scale-95"
                  aria-label="Remove"
                >
                  <i className="ri-delete-bin-7-fill text-2xl"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-no-repeat bg-contain bg-center bg-[url('@assets/images/ContactBorder.png')] w-full h-6 last:hidden max-md:hidden flex-shrink-0"></div>
    </>
  );
};

export default BookmarkMusics;
